import Parse from 'parse'

import { MyReduxUser } from '../store/slice/user'

//todo
export default function makeMyUserFromParseUser(user: Parse.User): MyReduxUser {
  return {
    sessionToken: user.getSessionToken(),
    name: user.getUsername(),
    objectId: user.id,
  }
}
